<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_x"><strong><em>Author’s Preface</em></strong></a></h1><a id="page_x">
<p class="para">Writing this commentary felt like coming home. The first book I studied in Greek was Colossians, in a class in New Testament Exegesis at Trinity Evangelical Divinity School in 1972. The notes from that class are the bottom layer (deeply buried now, alas) of this commentary. I have also had the opportunity to teach Colossians in academic settings and to teach it and preach it in several churches. All these experiences, and the things that I learned from those who studied with me, have fed my interpretation of this great letter. Philemon I have studied and taught less. But I do remember a series of three sermons on the book that I preached at a summer conference in the 1980s, and I surprised myself by basically confirming many of the points that I made about this book at that time.</p>
<p class="indent-para">I want to express appreciation to research assistants (and colleagues) Matt Harmon, Elisee Ouoba, and Laurie Norris for help with bibliography and proofreading. My wife, Jenny, read the entire MS in its last stages and offered invaluable suggestions about content (perhaps I should have listed her as coauthor!). I am also grateful to my former colleague Don Carson for allowing me to contribute this volume to the Pillar series. I dedicate this book to Murray J. Harris. He was my professor for that 1972 Colossians class, and his teaching in that class, elaborated and put into written form in his very useful exegetical commentary, has been foundational to my own thinking about Colossians. But he has taught me even more by his example as a scholar and a Christian gentleman. I am grateful to have studied under him and to have served with him.</p>
<p class="p-right">D<span class="smallcaps">OUGLAS</span> J. M<span class="smallcaps">OO</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Authorspreface.vue?4776fb1a